import React from 'react';
import { Box } from '@mui/material';
import Agents from './Agents';

const AgentsPage = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Agents />
    </Box>
  );
};

export default AgentsPage; 